import React from 'react';
import { NavLink } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import BrandMark from './BrandMark';

const { FiGrid, FiVideo, FiCheckSquare, FiTarget, FiSettings, FiBookOpen } = FiIcons;

const NAV_ITEMS = [
  { path: '/', icon: FiGrid, label: 'Command Center' },
  { path: '/library', icon: FiVideo, label: 'Meeting Matrix' },
  { path: '/actions', icon: FiCheckSquare, label: 'Action Stream' },
  { path: '/guide', icon: FiBookOpen, label: 'System Guide' },
];

export default function Sidebar() {
  return (
    <aside className="w-64 h-full glass-panel flex flex-col z-20 hidden md:flex border-y-0 border-l-0">
      <div className="p-6 flex items-center gap-3 border-b border-matrix-border/30">
        <BrandMark className="w-9 h-9" />
        <div className="flex flex-col">
          <span className="font-mono font-bold text-lg tracking-tighter text-white leading-none">MEET<span className="text-cyan-400">MATRIX</span></span>
          <span className="text-[9px] font-mono text-cyan-400/60 uppercase tracking-[0.2em] mt-1">Intelligence v2.4</span>
        </div>
      </div>

      <nav className="flex-1 py-8 px-4 space-y-1.5">
        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-300 group ${
                isActive
                  ? 'bg-cyan-400/10 text-cyan-400 border border-cyan-400/20 shadow-neon'
                  : 'text-gray-400 hover:text-white hover:bg-white/5 border border-transparent'
              }`
            }
          >
            <SafeIcon icon={item.icon} className="text-lg group-hover:scale-110 transition-transform" />
            <span className="font-medium text-sm tracking-wide">{item.label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="p-4 border-t border-matrix-border/30">
        <NavLink
          to="/settings"
          className={({ isActive }) =>
            `flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-300 ${
              isActive ? 'text-cyan-400 bg-cyan-400/10 border border-cyan-400/20' : 'text-gray-400 hover:text-white hover:bg-white/5'
            }`
          }
        >
          <SafeIcon icon={FiSettings} className="text-lg" />
          <span className="font-medium text-sm">System Config</span>
        </NavLink>
      </div>
    </aside>
  );
}